<template>
    <div class="appointments-not-created">
        <div class="appointments-not-created__title">
            <div class="appointments-not-created__icon">
                <CloseSmall class-name="icon-stroke icon_color_gray" />
            </div>

            Что-то пошло не так...
        </div>
        <div class="appointments-not-created__text">
            К сожалению, произошла техническая ошибка и мы уже работаем над устранением проблемы.<br>
            Попробуйте записаться в офис еще раз позже.
        </div>
        <div class="appointments-not-created__footer">
            <STBaseButton v-show="!isAfterUpdate"
                          text="Вернуться в начало"
                          icon-before="IconRightFill"
                          icon-before-modify="icon-fill icon_color_white"
                          modify="button_size_small icon-rotate"
                          @click="restartCreating" />

            <STBaseButton text="Смотреть записи"
                          modify="button_theme_white button_size_small"
                          @click="goToAppointments" />
        </div>
    </div>
</template>

<script>
import CloseSmall from '@/components/Icons/CloseSmall';

export default {
    name: 'AppointmentsNotCreated',

    components: {
        CloseSmall
    },

    props: {
        isAfterUpdate: {
            type   : [Boolean],
            default: false
        }
    },

    methods: {
        restartCreating() {
            this.$emit('restartCreating');
        },

        goToAppointments() {
            this.$emit('goToAppointments');
        }
    }
};
</script>

<style lang="scss">
@import "AppointmentsNotCreated";
</style>
